import { stripBasepath } from './stripBasepath'

const MAX_MARKER_AGE = 30 * 60 * 1000 // 30 minutes

export function cleanupStaleMarkers(): void {
    try {
        const markerStr = sessionStorage.getItem('authFlowMarker')
        if (!markerStr) return // No marker to clean up

        const marker = JSON.parse(markerStr)
        const isStale = Date.now() - marker.timestamp > MAX_MARKER_AGE

        // Get current path without basepath, with fallback
        const currentPath = stripBasepath(window.location.pathname) || '/'

        // Auth pages that should keep the marker
        const authPages = [
            '/login',
            '/register',
            '/forgot-password',
            '/onboarding',
        ]
        const isOnAuthPage = authPages.some((page) =>
            currentPath.startsWith(page)
        )

        // Only clean up if:
        // 1. Marker is stale (> 30 min old), OR
        // 2. We're definitely not on an auth page anymore
        if (isStale) {
            sessionStorage.removeItem('authFlowMarker')
        } else if (!isOnAuthPage) {
            // Double-check we're not in a transitional state
            // If pathname is just '/', it might be mid-navigation
            if (currentPath !== '/' || document.readyState === 'complete') {
                sessionStorage.removeItem('authFlowMarker')
            }
        }
    } catch (e) {
        // If anything fails, clean up to be safe
        console.error('Marker cleanup error:', e)
        sessionStorage.removeItem('authFlowMarker')
    }
}

export interface AuthFlowMarker {
    startPath: string
    historyLength: number
    timestamp: number
}
